import posthog from 'posthog-js';

const STORAGE_KEY = 'cookie-consent';

export type ConsentStatus = 'accepted' | 'rejected' | 'pending';

export function getConsentStatus(): ConsentStatus {
  const value = localStorage.getItem(STORAGE_KEY);
  if (value === 'accepted' || value === 'rejected') return value;
  return 'pending';
}

function upgradeToFullMode(): void {
  posthog.set_config({
    persistence: 'localStorage+cookie',
    person_profiles: 'identified_only',
  });
}

export function initAnalytics(): void {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key || posthog.__loaded) return;

  posthog.init(key, {
    api_host: 'https://eu.i.posthog.com',
    persistence: 'memory',
    person_profiles: 'never',
    capture_pageview: false,
    loaded: (ph) => {
      if (!import.meta.env.PROD) {
        ph.opt_out_capturing();
        return;
      }
      if (getConsentStatus() === 'accepted') {
        upgradeToFullMode();
      }
    },
  });
}

export function acceptConsent(): void {
  localStorage.setItem(STORAGE_KEY, 'accepted');
  if (import.meta.env.PROD) {
    upgradeToFullMode();
  }
}

export function rejectConsent(): void {
  localStorage.setItem(STORAGE_KEY, 'rejected');
}
